import axios from "axios";

export const createTicket = async (ticket) => {
    const response = await axios.post(`/api/tickets`, { ticket });
    return response.data;
};

export const updateTicket = async ticket => {
    const response = await axios.put(`/api/tickets`, { ticket });
    return response.data;
};

export const getTicket = async id => {
    const response = await axios.get(`/api/tickets/${id}`);
    return response.data;
};

export const deleteTicket = async id => {
    const response = await axios.delete(`/api/tickets/${id}`);
    return response.data;
};
